import React from 'react';
import { connect } from 'react-redux';
import { withStyles } from '@mui/styles';

import { BellIcon } from './../commons/Icons';

import Badge from '@mui/material/Badge';
import CircularProgress from '@mui/material/CircularProgress';

class NotificationsIcon extends React.Component {

  render() {
    const { classes, appStore } = this.props;

    if (appStore.notifications_count && appStore.notifications_count === 'loading') {
      return (
        <CircularProgress color="secondary" size={25} />
      );
    }
    if (appStore.notifications_count && appStore.notifications_count === 'error') {
      return (
        <BellIcon />
      );
    }
    if (appStore.notifications_count && appStore.notifications_count > 0) {
      return (
        <Badge className={classes.badge} badgeContent={appStore.notifications_count}  color="primary">
          <BellIcon />
        </Badge>
      );
    }
    return (
      <BellIcon />
    );
  }
}

const styles = theme => ({
  badge: {},
});

const mapStateToProps = state => ({
	appStore: state.app,
});

export default withStyles(styles, { withTheme: true })(connect(mapStateToProps)(NotificationsIcon));
